import * as api from "../../../api/index";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import Profile from "../../Translator/Profile/Profile";

import { getUnapprovedTranslators } from "../../../actions/translator";
import {
  ALERT,
  COUNTER,
  REMOVE_UNAPPROVED_TRANSLATORS,
} from "../../../constants/actionTypes";

import "./Unapproved.css";
import { KeyboardArrowDown } from "@material-ui/icons";

const Unapproved = () => {
  dayjs.extend(relativeTime);
  const history = useHistory();
  const dispatch = useDispatch();
  const counter = useSelector((state) => state.counter);
  const translators = useSelector((state) => state.translators.unapproved);
  const [loading, setLoading] = useState(true);
  const [approving, setApproving] = useState(false);
  const [declining, setDeclining] = useState(false);
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [translator, setTranslator] = useState({});
  const [showProfile, setShowProfile] = useState(false);
  const [skip, setSkip] = useState(0);
  const [profile, setProfile] = useState({});

  const getTranslators = useCallback(() => {
    dispatch(
      getUnapprovedTranslators(
        {
          who: { "membership.approved": false, "membership.applied": true },
          skip: 0,
        },
        setLoading
      )
    );
  }, [dispatch]);

  const handleNextPage = async () => {
    dispatch(
      getUnapprovedTranslators(
        {
          who: { "membership.approved": false, "membership.applied": true },
          skip: skip + 20,
        },
        setLoading
      )
    );

    setSkip((skip) => skip + 20);
  };

  const openModal = (type, translator) => {
    setTranslator(translator);
    setType(type);
    document.querySelector(".unapproved__details").open = true;
  };

  const closeModal = () => {
    document.querySelector(".unapproved__details").open = false;
    setType("");
    setTranslator({});
  };

  const handleApprove = async () => {
    setApproving(true);

    try {
      await api.updateUser(translator._id, {
        "membership.approved": true,
        "membership.applied": false,
      });
      await api.counter({ unapproved_translators: -1 });
      await api.sendEmail({
        name: translator.name,
        email: translator.email,
        message: `Congratulations your profile has been reveiwed and we are glad to welcome you as one of our translators.`,
        subject: "Welcome To OneConverse Translations",
      });
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          unapproved_translators: counter.unapproved_translators - 1,
        },
      });
      if (translators.length < 2) history.push("/admin/index");
      closeModal();
      dispatch({ type: REMOVE_UNAPPROVED_TRANSLATORS, id: translator._id });
    } catch (error) {
      console.log(error);
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    } finally {
      setApproving(false);
    }
  };

  const handleDecline = async () => {
    setDeclining(true);

    try {
      await api.updateUser(translator._id, {
        "membership.approved": false,
        "membership.applied": false,
        rejection_msg: { message, createdAt: new Date() },
      });
      await api.counter({ unapproved_translators: -1 });
      await api.sendEmail({
        name: translator.name,
        email: translator.email,
        message: `Thank you for showing interest to become one of our translators, but we are sorry to reject your application at this time, you can review your profile and reapply.`,
        subject: "Profile Review - OneConverse Translations",
      });
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          unapproved_translators: counter.unapproved_translators - 1,
        },
      });
      if (translators.length < 2) history.push("/admin/index");
      closeModal();
      dispatch({ type: REMOVE_UNAPPROVED_TRANSLATORS, id: translator._id });
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    } finally {
      setDeclining(false);
    }
  };

  const handleOpenProfile = (translator) => {
    setProfile(translator);
    setShowProfile(true);
  };

  useEffect(() => {
    if (translators.length === 0) getTranslators();
    else setLoading(false);
  }, [getTranslators, translators]);

  useEffect(() => {
    if (showProfile) {
      document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("BODY")[0].style.overflow = "auto";
    }
  }, [showProfile]);

  return (
    <>
      {showProfile && (
        <Profile
          user={profile}
          loading={false}
          setShowProfile={setShowProfile}
          usersLength={translators.length}
          counter={counter}
          admin
        />
      )}
      <div className="pending">
        <h2 className="mb-40 py-20 font-subhead">
          UNAPPROVED TRANSLATORS
          <span
            style={{ background: "rgb(255, 145, 180)", color: "darkred" }}
            className="admin__project__counter text-center font-bigger px-40 ml-20 curved-20"
          >
            {translators.length}
          </span>
        </h2>
        <div className="admin__scroll__ctn">
          <div className="admin__scroll__1024 d-flex w-100 mb-40">
            <span className="admin__serial font-bold">S/N</span>
            <div className="grid c-6 w-90 px-10">
              <span className="font-bold">Translator</span>
              <span className="font-bold">Translation</span>
              <span className="font-bold">Certified/Sworn</span>
              <span className="font-bold">Experience</span>
              <span className="font-bold">Registered</span>
            </div>
          </div>
          {loading ? (
            <div className="loader mx-auto">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          ) : (
            <>
              {translators.length < 1 && (
                <div className="font-bolder font-bigger text-center">
                  No unapproved translator
                </div>
              )}
              {translators.map((translator, index) => (
                <div
                  className="admin__projects admin__scroll__1024 d-flex align-center pointer mb-20"
                  key={translator.email}
                >
                  <span className="admin__serial font-bold">{index + 1}</span>
                  <div className="position-relative grid align-center c-6 w-90 p-10 my-10 rounded box-shadow-lg">
                    <span
                      title={translator.name}
                      className="admin__projects__profile ellipsis pr-10 text-capitalise"
                      onClick={() => handleOpenProfile(translator)}
                    >
                      {translator.name}
                    </span>
                    <span
                      title={`${translator.source_lang} to ${translator.target_lang}`}
                      className="text-uppercase ellipsis pr-10"
                    >
                      {translator.source_lang.substring(0, 2)}-
                      {translator.target_lang.substring(0, 2)}
                    </span>
                    <span
                      title={`${
                        translator.certified === "yes"
                          ? "Certified"
                          : "Not certified"
                      } and ${
                        translator.sworn === "yes" ? "Sworn" : "Not sworn"
                      }`}
                    >
                      {translator.certified}/{translator.sworn}
                    </span>
                    <span
                      title={`${translator.experience} year${
                        translator.experience > 1 ? "s" : ""
                      } experience`}
                    >
                      {`${translator.experience} year${
                        translator.experience > 1 ? "s" : ""
                      }`}
                    </span>
                    <span
                      title={dayjs(translator.createdAt).format(
                        "dddd, MMMM D YYYY"
                      )}
                    >
                      {dayjs(translator.createdAt).fromNow()}
                    </span>
                    <div className="d-flex justify-between">
                      <button
                        className="border-0 outline-0 w-45 font-bold rounded"
                        onClick={() => openModal("approve", translator)}
                      >
                        Approve
                      </button>
                      <button
                        style={{ backgroundColor: "crimson" }}
                        className="border-0 outline-0 w-45 font-bold rounded"
                        onClick={() => openModal("decline", translator)}
                      >
                        Decline
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
          {!loading && translators > 19 && (
            <div
              className="d-flex justify-center p-20 pointer"
              onClick={handleNextPage}
            >
              <div className="d-flex align-center border-1 px-20 py-5 curved-20">
                <span className="font-bold">View More</span>
                <KeyboardArrowDown className="ml-5" fontSize="large" />
              </div>
            </div>
          )}
        </div>
      </div>
      <details className="unapproved__details">
        <summary className="list-none"></summary>
        <div className="d-flex align-center justify-center position-fixed t-0 r-0 w-100 h-100 z-5">
          <div className="d-flex flex-column align-center text-center p-20">
            {
              <h3 className="font-subhead">
                {type === "approve" ? "Approve" : "Decline"} Translator
              </h3>
            }
            {type === "approve" && (
              <p className="font-heavy font-big py-40">
                You are are approving {translator.name},{" "}
                {translator.source_lang} to {translator.target_lang} Translator
                as a OneConverse Translator
              </p>
            )}
            {type === "decline" && (
              <div>
                <p className="font-heavy font-big py-10">
                  Input reason for declining
                </p>
                <textarea
                  className="mt-10 mb-40 w-100 border-0 outline-0 p-10 border-1 box-shadow-lg"
                  placeholder="..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            )}
            <div className="d-flex justify-between">
              <button
                className="unapproved__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                onClick={closeModal}
              >
                Cancel
              </button>
              {type === "approve" && (
                <button
                  style={{ opacity: translators === {} ? "0.6" : "" }}
                  className="unapproved__btn__aprrove d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleApprove}
                  disabled={translators === {}}
                >
                  Approve
                  {approving && <div className="spin-white ml-10"></div>}
                </button>
              )}
              {type === "decline" && (
                <button
                  style={{
                    opacity: message === "" || translators === {} ? "0.6" : "",
                  }}
                  className="unapproved__btn__decline d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleDecline}
                  disabled={message === "" || translators === {}}
                >
                  Decline
                  {declining && <div className="spin-white ml-10"></div>}
                </button>
              )}
            </div>
          </div>
        </div>
      </details>
    </>
  );
};

export default Unapproved;
